import { useUserData } from 'components/user/hooks/use-user-data';
import { classNames } from 'components/class-names';
import { Link } from 'components/router/Link';
import { Button } from 'components/button/Button';
import * as React from 'react';
import SvgSprite from 'components/html-elements/SvgSprite';
import { When } from 'react-if';
import { FC } from 'react';

type PropTypes = {
  count: number;
  createProjectModalShow: () => void;
};

const CartNotifierLink: FC<PropTypes> = ({
  count,
  createProjectModalShow,
}) => {
  const userData = useUserData();

  const renderContent = () => (
    <>
      <SvgSprite id="cart" size={16} />
      <When condition={count}>
        <span className="font-weight-bold ml-4p">
          {count}
        </span>
      </When>
    </>
  );

  const className = classNames('text-decoration-none text-reset d-flex align-items-center mr-16p mr-xl-0');
  if (userData.hasProjects) {
    return (
      <Link to="/cart" className={className}>
        {renderContent()}
      </Link>
    );
  }

  return (
    <Button additionalClassName={className} onClick={createProjectModalShow}>
      {renderContent()}
    </Button>
  );
};

export { CartNotifierLink };
